import { all, fork } from 'redux-saga/effects';
import authSaga from './auth';
import itemsSaga from './items';

export default function* sagas() {

    yield all( [
        fork( authSaga ),
        fork( itemsSaga )
    ] );

};